import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './client.reducer';

export const ClientDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const clientEntity = useAppSelector(state => state.client.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="clientDetailsHeading">
          <Translate contentKey="alexisExportApp.client.detail.title">Client</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{clientEntity.id}</dd>
          <dt>
            <span id="nom">
              <Translate contentKey="alexisExportApp.client.nom">Nom</Translate>
            </span>
          </dt>
          <dd>{clientEntity.nom}</dd>
          <dt>
            <span id="prenom">
              <Translate contentKey="alexisExportApp.client.prenom">Prenom</Translate>
            </span>
          </dt>
          <dd>{clientEntity.prenom}</dd>
          <dt>
            <span id="raisonSociale">
              <Translate contentKey="alexisExportApp.client.raisonSociale">Raison Sociale</Translate>
            </span>
          </dt>
          <dd>{clientEntity.raisonSociale}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="alexisExportApp.client.email">Email</Translate>
            </span>
          </dt>
          <dd>{clientEntity.email}</dd>
          <dt>
            <span id="phone">
              <Translate contentKey="alexisExportApp.client.phone">Phone</Translate>
            </span>
          </dt>
          <dd>{clientEntity.phone}</dd>
          <dt>
            <span id="addresseDeLivraison">
              <Translate contentKey="alexisExportApp.client.addresseDeLivraison">Addresse De Livraison</Translate>
            </span>
          </dt>
          <dd>{clientEntity.addresseDeLivraison}</dd>
          <dt>
            <span id="codePostale">
              <Translate contentKey="alexisExportApp.client.codePostale">Code Postale</Translate>
            </span>
          </dt>
          <dd>{clientEntity.codePostale}</dd>
          <dt>
            <span id="ville">
              <Translate contentKey="alexisExportApp.client.ville">Ville</Translate>
            </span>
          </dt>
          <dd>{clientEntity.ville}</dd>
          <dt>
            <span id="pays">
              <Translate contentKey="alexisExportApp.client.pays">Pays</Translate>
            </span>
          </dt>
          <dd>{clientEntity.pays}</dd>
          <dt>
            <span id="datePersistence">
              <Translate contentKey="alexisExportApp.client.datePersistence">Date Persistence</Translate>
            </span>
          </dt>
          <dd>
            {clientEntity.datePersistence ? <TextFormat value={clientEntity.datePersistence} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="dateUpdate">
              <Translate contentKey="alexisExportApp.client.dateUpdate">Date Update</Translate>
            </span>
          </dt>
          <dd>{clientEntity.dateUpdate ? <TextFormat value={clientEntity.dateUpdate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="alexisExportApp.client.rebuts">Rebuts</Translate>
          </dt>
          <dd>{clientEntity.rebuts ? clientEntity.rebuts.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/client" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/client/${clientEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ClientDetail;
